import { useState } from "react";

// Type for inappropriate word check result
export interface InappropriateCheckResult {
  isInappropriate: boolean;
  errorMessage: string;
}

// Type for inappropriate word check options
export interface InappropriateCheckOptions {
  onError?: (result: InappropriateCheckResult) => void;
  customWords?: string[];
}

export const useInappropriateWordsCheck = (options?: InappropriateCheckOptions) => {
  const [isInappropriate, setIsInappropriate] = useState(false);

  // TODO: Default inappropriate words list (should be managed by external config or API ??)
  const defaultInappropriateWords = ["不適切"];

  const checkText = (text: string): InappropriateCheckResult => {
    const wordsToCheck = [...defaultInappropriateWords, ...(options?.customWords || [])];

    const hasInappropriateWord = wordsToCheck.some((word) => text.includes(word));

    const result = {
      isInappropriate: hasInappropriateWord,
      errorMessage: hasInappropriateWord ? "その言葉は不適切なため、使用できません。" : "",
    };

    setIsInappropriate(hasInappropriateWord);
    options?.onError?.(result);

    return result;
  };

  const resetCheck = () => {
    setIsInappropriate(false);
  };

  return {
    isInappropriate,
    checkText,
    resetCheck,
  };
};
